export default __webpack_public_path__ + "static/media/logo1.88ccbc63.png";